import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../../components/pages/NotFoundView'
import { useAuthToken } from '../../providers/AuthProvider'
import RedirectUtility from './Redirect'
import CallbackUtility from './Callback'

function ExternalUtilityApp () {
  const { path } = useRouteMatch()
  const { isLoading } = useAuthToken()

  if (isLoading) {
    return null
  }

  return (
    <Switch>
      <SecureRoute path={`${path}/redirect/:token`}>
        <RedirectUtility />
      </SecureRoute>
      <SecureRoute path={`${path}/callback/:provider`}>
        <CallbackUtility />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default ExternalUtilityApp
